import { Eye, EyeOff } from 'lucide-react';
import type * as React from 'react';
import { useState } from 'react';

import { Input } from '@/components/lumen/input';
import { useLanguage } from '@contexts/LanguageContext';
import { cn } from '@/lib/utils';

/**
 * Lumen Input with the show/hide toggle the old Mantine PasswordInput had. Props (and the ref, via
 * React 19's ref prop) go to the <input>, so it drops into a FormControl like Input does.
 */
export function PasswordInput({ className, disabled, ...props }: Omit<React.ComponentProps<'input'>, 'type'>) {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  return (
    <div className="relative">
      <Input type={visible ? 'text' : 'password'} disabled={disabled} className={cn('pr-10', className)} {...props} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        disabled={disabled}
        aria-label={t(visible ? 'lumen.auth.hidePassword' : 'lumen.auth.showPassword')}
        aria-pressed={visible}
        className="absolute inset-y-0 right-0 flex w-9 items-center justify-center rounded-r-control text-fg-muted outline-none transition-colors hover:text-fg focus-visible:ring-[3px] focus-visible:ring-label/40 disabled:pointer-events-none disabled:opacity-50"
      >
        {visible ? <EyeOff className="size-4" aria-hidden="true" /> : <Eye className="size-4" aria-hidden="true" />}
      </button>
    </div>
  );
}
